import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Lab Sub Center
function createLabSubCenter(params: any) {
    const baseUrl = `/subc/createSubc`;
    return api.create(`${baseUrl}`, params);
}
// update Lab Sub Center
function updateLabSubCenter(params: any) {
    const baseUrl = '/subc/updateSubc';
    return api.create(`${baseUrl}`, params);
}

// get all Lab Sub Center
function getAllLabSubCenter(params: any) {
    const baseUrl = '/subc/getSubc';
    return api.create(`${baseUrl}`, params);
}

// get Lab Sub Center
function getLabSubCenter(params: any) {
    const baseUrl = '/subc/getSubCenterDetail';
    return api.create(`${baseUrl}`, params);
}

export { createLabSubCenter, updateLabSubCenter, getAllLabSubCenter, getLabSubCenter };
